<app-dialog
  [headerLabel]="'DIALOG.DEPOSIT_REQUEST.TITLE' | translate"
  [primaryActionText]="'ACTION.SAVE' | translate"
  [primaryActionTapped]="primaryActionTapped"
  [secondaryActionText]="
    cancellable
      ? ('DIALOG.DEPOSIT_REQUEST.CANCEL_DEPOSIT_REQUEST' | translate)
      : null
  "
  [secondaryActionTapped]="secondaryActionTapped"
  [isSecondaryActionDestroying]="cancellable"
  [dialogType]="dialogType"
  [centerActions]="true"
  [trackingScreenName]="documentTrackingScreenName"
  [trackingDialogName]="trackingDialogName"
  [primaryActionDisabled]="form?.invalid || !depositSavable"
  [secondaryActionDisabled]="!depositSavable"
  (onPrimaryAction)="saveDepositRequest()"
  (onSecondaryAction)="depositSavable && onCancelRequest.emit()"
>
  <div id="deposit-request-dialog" class="tabbed-view">
    <div class="document-balance">
      <span>
        {{ documentTotalLabel }}
      </span>

      <span>
        {{
          documentCalculationResult?.total
            | money: documentCurrencyCode:documentLocale
        }}
      </span>
    </div>

    <ul class="tabs">
      <li
        *ngFor="let tab of tabs"
        class="tab"
        [ngClass]="{ selected: selectedTab === tab.value }"
        trackable
        [trackingObject]="documentTrackingObject"
        [trackingAction]="tab.trackingAction"
        (click)="selectTab(tab.value)"
      >
        {{ tab.key }}
      </li>
    </ul>

    <app-form-master
      *ngIf="form"
      [form]="form"
      class="tab-content"
      [ngSwitch]="selectedTab"
      (submitForm)="saveDepositRequest()"
    >
      <div
        *ngSwitchCase="DepositRequestTabsEnum.percent"
        class="contents-wrapper"
      >
        <app-percentage-field
          class="form-row"
          [label]="'DIALOG.DEPOSIT_REQUEST.SET_PERCENTAGE' | translate"
          fieldId="deposit_request_set_percentage_field"
          [locale]="documentLocale"
          [min]="0"
          [max]="100"
          [errorMessages]="percentageErrorMessages"
          [formControl]="form.get(formKeys.PERCENTAGE_PERCENT)"
        >
        </app-percentage-field>

        <app-currency-field
          class="form-row"
          [label]="'DIALOG.DEPOSIT_REQUEST.DEPOSIT_AMOUNT' | translate"
          fieldId="deposit_request_percent_amount_field"
          [currencyCode]="documentCurrencyCode"
          [locale]="documentLocale"
          [errorMessages]="amountErrorMessages"
          [formControl]="form.get(formKeys.PERCENTAGE_FIXED_AMOUNT)"
        >
        </app-currency-field>

        <app-date-picker-field
          class="form-row"
          [label]="'DIALOG.DEPOSIT_REQUEST.DUE_DATE' | translate"
          fieldId="deposit_request_due_date_field"
          [options]="depositDateDatePickerOptions"
          [formControl]="form.get(formKeys.DUE_DATE)"
        >
        </app-date-picker-field>

        <app-toggle-field
          *ngIf="depositToggleAccess"
          class="form-row add-deposit-for-future"
          fieldId="add_deposit_for_future"
          trackingIdentifier="deposit_settings"
          [label]="addDepositForFutureLabel"
          [fieldControl]="form.get(formKeys.ADD_DEPOSIT_FOR_FUTURE)"
          [trackingObject]="documentTrackingObject"
          [trackingScreenName]="documentTrackingScreenName"
        >
        </app-toggle-field>
      </div>

      <div
        *ngSwitchCase="DepositRequestTabsEnum.fixed"
        class="contents-wrapper"
      >
        <app-currency-field
          class="form-row"
          [label]="'DIALOG.DEPOSIT_REQUEST.DEPOSIT_AMOUNT' | translate"
          fieldId="deposit_request_fixed_amount_field"
          [currencyCode]="documentCurrencyCode"
          [locale]="documentLocale"
          [errorMessages]="amountErrorMessages"
          [formControl]="form.get(formKeys.FIXED_AMOUNT)"
        >
        </app-currency-field>

        <app-date-picker-field
          class="form-row"
          [label]="'DIALOG.DEPOSIT_REQUEST.DUE_DATE' | translate"
          fieldId="deposit_request_due_date_field"
          [options]="depositDateDatePickerOptions"
          [formControl]="form.get(formKeys.DUE_DATE)"
        >
        </app-date-picker-field>
      </div>

      <div
        *ngIf="documentCalculationResult?.payments.deposit?.isUnpaid()"
        class="deposit-paid-amount"
      >
        <span>
          {{ 'DIALOG.DEPOSIT_REQUEST.AMOUNT_PAID' | translate }}
        </span>

        <span>
          {{
            documentCalculationResult.payments.deposit.amountPaid
              | money: documentCurrencyCode:documentLocale
          }}
        </span>
      </div>
    </app-form-master>
  </div>
</app-dialog>
